import BookingBackground from './BookingBackground';

export default BookingBackground;
